module.exports = __webpack_public_path__ + "img/log.f42a197f.svg";